import { createReducer } from 'redux-starter-kit';
import _ from 'lodash';

import { ServiceRequestApi } from './ServiceRequestApi';
import Notice from '../../modules/utils/Notice';
import { handleError } from '../../modules/utils/handleError';
import Dict from '../../modules/utils/Dict';
import { translation } from '../../_helpers/Translate';
import { history } from '../../_helpers/history';
import paths from '../../_helpers/paths';
import { NCALayerSign } from '../../modules/NCALayer/NCALayerSign';
import { changeFormValue } from '../../passport/Passport';
import { services } from '../../_helpers/Constants';
import { ServiceProvidersApi } from './ServiceProvidersModal/ServiceProvidersApi';
import i18next from 'i18next';
import moment from 'moment';
import PassportForm from '../../passport/FormData/PassportForm';

/**
 * Constants
 */
export const serviceRequestModule = 'serviceRequest';
const LOAD_DATA_REQUEST = `${serviceRequestModule}/LOAD_DATA_REQUEST`;
const SET_DATA_REQUEST = `${serviceRequestModule}/SET_DATA_REQUEST`;
const LOAD_SAVING_REQUEST = `${serviceRequestModule}/LOAD_SAVING_REQUEST`;
const CLEAR_STATE = `${serviceRequestModule}/CLEAR_STATE`;
const LOADING_ACTION = `${serviceRequestModule}/LOADING_ACTION`;
const DISABLE_FORM_BUTTON = `${serviceRequestModule}/DISABLE_FORM_BUTTON`;
const BIN_FUNDER = `${serviceRequestModule}/BIN_FUNDER`;
const SET_DDO_SHORT_DISABLED = `${serviceRequestModule}/SET_DDO_SHORT_DISABLED`;
const LOADING_INTEGRATION = `${serviceRequestModule}/LOADING_INTEGRATION`;
const SET_INTEGRATION_STATUS = `${serviceRequestModule}/SET_INTEGRATION_STATUS`;
const SET_SHOW_CHECK_CONTINGENT_MODAL = `${serviceRequestModule}/SET_SHOW_CHECK_CONTINGENT_MODAL`;
const SET_ZAGS_STATUS = `${serviceRequestModule}/SET_ZAGS_STATUS`;

export const VERIFY_REQUEST_ADDRESS = `${serviceRequestModule}/VERIFY_REQUEST_ADDRESS`;

/**
 * Reducer
 */
export const initialState = {
  meta: null,
  data: {},
  loading: false,
  loadingSave: false,
  loadingAction: false,
  disableFormButton: false,
  bin: null,
  ddoShortDisabled: false,
  loadingIntegration: false,
  kdpGbdflStatus: null,
  kdpZagsStatus: null,
  showCheckContingentModal: false,
  addressVerified: null
};

export default createReducer(initialState, {
  [LOAD_DATA_REQUEST]: (state, action) => {
    state.loading = action.loading;
  },
  [LOAD_SAVING_REQUEST]: (state, action) => {
    state.loadingSave = action.loading;
  },
  [SET_DATA_REQUEST]: (state, action) => {
    state.meta = action.meta;
    state.data = action.data || { metadataKey: action.meta.id };
  },
  [LOADING_ACTION]: (state, action) => {
    state.loadingAction = action.loading;
  },
  [DISABLE_FORM_BUTTON]: (state, action) => {
    state.disableFormButton = action.payload;
  },
  [BIN_FUNDER]: (state, action) => {
    state.bin = action.payload;
  },
  [SET_DDO_SHORT_DISABLED]: (state, action) => {
    state.ddoShortDisabled = action.payload;
  },
  [CLEAR_STATE]: () => initialState,

  [SET_INTEGRATION_STATUS]: (state, action) => {
    state.kdpGbdflStatus = action.payload;
  },
  [LOADING_INTEGRATION]: (state, action) => {
    state.loadingIntegration = action.loadingIntegration;
  },
  [SET_ZAGS_STATUS]: (state, action) => {
    state.kdpZagsStatus = action.payload;
  },
  [SET_SHOW_CHECK_CONTINGENT_MODAL]: (state, action) => {
    state.showCheckContingentModal = action.payload;
  },
  [VERIFY_REQUEST_ADDRESS]: (state, action) => {
    state.addressVerified = action.payload;
  }
});

/**
 * Action Creators
 */

export const disableFormButton = disable => ({
  type: DISABLE_FORM_BUTTON,
  payload: disable
});

export const loadingData = (id, metadataKey) => async (dispatch, getState) => {
  dispatch({ type: LOAD_DATA_REQUEST, loading: true });
  try {
    if (id) {
      const { data } = await ServiceRequestApi.loadData(id);
      const response = await ServiceRequestApi.loadMetaData(data.metadataKey);
      const filter = JSON.stringify({ id: data.serviceProviderId });
      const { data: serviceProviderData } = await ServiceRequestApi.serviceProvider(
        filter
      );
      let serviceProvider;
      if (serviceProviderData.result.content.length) {
        serviceProvider = serviceProviderData.result.content[0];
      }
      const dictStatuses = await Dict.itemsObject('gu_status_res');
      const dictResolutions = await Dict.itemsObject('gu_status_pr');
      dispatch({
        type: SET_DATA_REQUEST,
        meta: response.data,
        data: {
          ...data,
          serviceProvider,
          ruProcessingStatus: dictStatuses[data.processingStatus][`ru_name`],
          kkProcessingStatus: dictStatuses[data.processingStatus][`kk_name`],
          ruResolutionType: dictResolutions[data.resolutionType][`ru_name`],
          kkResolutionType: dictResolutions[data.resolutionType][`kk_name`],
          requesterIin: getState().login.user.iin
        }
      });
    } else {
      const response = await ServiceRequestApi.loadMetaData(
        `request_form_${metadataKey}`
      );
      dispatch({ type: SET_DATA_REQUEST, meta: response.data });
    }
  } catch (errorCode) {
    handleError(errorCode, 'serviceRequestDucks_loadDataFailed');
  } finally {
    dispatch({ type: LOAD_DATA_REQUEST, loading: false });
  }
};

export const onSave = (formData, method) => async dispatch => {
  dispatch({ type: LOAD_SAVING_REQUEST, loading: true });
  let parsedFilter = null;
  const params = new URLSearchParams(window.location.search);
  const filterParam = params.get('filter');
  if (filterParam) {
    try {
      parsedFilter = JSON.parse(filterParam);
    } catch (e) {}
  }
  try {
    if (formData) {
      if (
        [
          'doc_queued_ddo_short',
          'voucher_queue_short',
          'accept_school_short',
          'accept_doc_edu_short'
        ].includes(formData.serviceType)
      ) {
        formData.requestFormChanges.forEach((requestFormItem, i) => {
          if (requestFormItem.questionCode === 'child_birthday') {
            let newValue = _.get(requestFormItem, 'newValue[0].timestamp');
            if (newValue && newValue.toString().includes('T') === false) {
              formData.requestFormChanges[i].newValue[0].timestamp =
                moment(newValue).format('YYYY-MM-DD') + 'T00:00:00';
            }
          }
        });
      } else if (formData.serviceType === 'payment_patronage_short') {
        formData.requestFormChanges.forEach((requestFormItem, i) => {
          if (requestFormItem.questionCode === 'fostercare_child_birthday') {
            let newValue = _.get(requestFormItem, 'newValue[0].timestamp');
            if (newValue && newValue.toString().includes('T') === false) {
              formData.requestFormChanges[i].newValue[0].timestamp =
                moment(newValue).format('YYYY-MM-DD') + 'T00:00:00';
            }
          }
        });
      } else if (formData.serviceType === 'payment_family_short') {
        formData.requestFormChanges.forEach((requestFormItem, i) => {
          if (requestFormItem.questionCode === 'guardianship_child_birthday') {
            let newValue = _.get(requestFormItem, 'newValue[0].timestamp');
            if (newValue && newValue.toString().includes('T') === false) {
              formData.requestFormChanges[i].newValue[0].timestamp =
                moment(newValue).format('YYYY-MM-DD') + 'T00:00:00';
            }
          }
        });
      } else if (formData.serviceType === 'children_adoption_short') {
        formData.requestFormChanges.forEach((requestFormItem, i) => {
          if (requestFormItem.questionCode === 'guardianship_child_birthday') {
            let newValue = _.get(requestFormItem, 'newValue[0].timestamp');
            if (newValue && newValue.toString().includes('T') === false) {
              formData.requestFormChanges[i].newValue[0].timestamp =
                moment(newValue).format('YYYY-MM-DD') + 'T00:00:00';
            }
          }
        });
      }
    }
    const { data } = await ServiceRequestApi.getSignString(formData);
    const signString = data['result']['signature'];
    const signedString = await NCALayerSign(signString, false, method, false);

    if (!signedString) {
      return Notice.warning(translation('serviceRequestDucks_signCanceled'));
    }

    let response;
    if (formData.id) {
      response = await ServiceRequestApi.updateRequestForm({
        ...formData,
        signature: signedString
      });
    } else {
      response = await ServiceRequestApi.createRequestForm({
        ...formData,
        signature: signedString
      });
    }

    if (response.data.results.length === 0) {
      if (parsedFilter?.kindergartenVoucherId && parsedFilter?.status === 'RESERVED') {
        const iin =
          PassportForm.values['request_form_voucher_acceptance_ddo_short.child_iin'];
        const contingentResponse = await ServiceRequestApi.getContingentCheck(iin);
        const contingentResult = contingentResponse.data?.result?.[0];
        const contingentStatus = contingentResult?.contingentStatus;
        Notice.success(translation('serviceRequestDucks_saveSuccess'));
        if (contingentStatus === 'ENROLLED') {
          dispatch(setShowCheckContingentModal(true));
        } else {
          history.push(paths.voucherWaitingList);
        }
      } else {
        Notice.success(translation('serviceRequestDucks_saveSuccess'));
        if (['voucher_acceptance_ddo_short'].includes(formData.serviceType)) {
          history.push(paths.voucherAppointments);
        } else if (['doc_acceptance_ddo_short'].includes(formData.serviceType)) {
          history.push(paths.kindergartenAppointments);
        } else {
          history.push(paths.homePage);
        }
      }
    } else {
      handleError(response, translation('serviceRequestDucks_saveFailed'));
    }
  } catch (e) {
    const errorCode = _.get(e, 'response.data.errors[0].code');
    if (errorCode === 'error.runtime_user_must_sing_own_signature') {
      Notice.error(translation('must_sing_own_signature'));
    } else if (errorCode === 'error.request_form_already_exist') {
      Notice.error(translation('serviceRequest_supplierApplicationRequestAlreadyExists'));
    } else {
      handleError(e, translation('serviceRequestDucks_saveFailed'));
    }
  } finally {
    dispatch({ type: LOAD_SAVING_REQUEST, loading: false });
  }
};

export const getServiceProvider = (id, metadataKey) => async dispatch => {
  try {
    dispatch({ type: LOADING_ACTION, loading: true });
    const filter = JSON.stringify({
      id,
      pageSize: 1,
      pageNumber: 1
    });
    const { data } = await ServiceRequestApi.serviceProvider(filter);
    const { content } = data.result;
    if (content.length > 0) {
      if (metadataKey === services.academical_resignations_short.code) {
        changeFormValue(
          'request_form_academical_resignations_short.location',
          content[0].location
        );
      }
    }
  } catch (error) {
    handleError(error, translation('serviceRequestDucks_loadDataFailed'));
  } finally {
    dispatch({ type: LOADING_ACTION, loading: false });
  }
};
export const searchServiceProvider = async (
  queuedRegion,
  switchSPBIN,
  setServiceProvider,
  serviceType,
  typeCode = '13'
) => {
  try {
    let filter = {};
    let bin;
    let kato = queuedRegion ? queuedRegion.code.slice(0, 4) : null;
    if ((kato === '1910' || kato === '3310') && serviceType === 'doc_queued_ddo') {
      Notice.error(translation('serviceRequestDucks_searchFailed'));
      changeFormValue('request_form_doc_queued_ddo_short.queued_region', null);
    }
    if (kato) {
      let kato = queuedRegion.code.slice(0, 4);
      bin = switchSPBIN([], kato);
      kato = kato + '00000';
      filter = {
        pageNumber: 1,
        pageSize: 100,
        legalLocality: kato,
        serviceType: serviceType,
        serviceProviderType: '0',
        typeCode: typeCode
      };
      let { data } = await ServiceProvidersApi.searchServiceProvider(filter);
      if (data.content) {
        const content = [];
        for (let row of data.content) {
          const item = {};
          for (let r of row.passportValues) {
            item[r.code] = r.value;
          }
          content.push(item);
        }
        if (content.length > 0) {
          const findContent = content.find(el => el.bin === bin);
          if (findContent) {
            setServiceProvider(findContent);
          } else {
            if (content.length === 1) {
              setServiceProvider(content[0]);
            } else {
              setServiceProvider(null);
            }
          }
        }
      }
    } else {
      setServiceProvider(null);
    }
  } catch (error) {
    handleError(error, i18next.t('serviceProviders_errorLoadTable'));
  }
};

export const clearState = () => dispatch => {
  dispatch({ type: CLEAR_STATE });
};

export const saveBinFunder = bin => dispatch => {
  dispatch({ type: BIN_FUNDER, payload: bin });
};

export const chengDDOShortDisabled = isDisabled => dispatch => {
  dispatch({ type: SET_DDO_SHORT_DISABLED, payload: isDisabled });
};

// export const setZagsStatus = status => dispatch => {
//   dispatch({ type: SET_ZAGS_STATUS, payload: status });
// };

export const enableIntegrationForServices = ({ close, onStatus }) => async dispatch => {
  try {
    dispatch({ type: LOADING_INTEGRATION, loadingIntegration: true });
    const { data: dataGbdfl } = await ServiceProvidersApi.startGbdfl({
      isConsentProvided: true
    });
    const { data: dataZags } = await ServiceProvidersApi.startZags({
      isConsentProvided: true
    });
    if (dataGbdfl.result && dataZags.result) {
      const statusGbdfl = dataGbdfl.result.kdpGbdflStatus;
      const statusZags = dataZags.result.kdpZagsStatus;
      dispatch({ type: SET_ZAGS_STATUS, payload: statusZags });
      if (statusGbdfl === 'VALID' && statusZags === 'VALID') {
        dispatch({ type: LOADING_INTEGRATION, loadingIntegration: false });
        close();
        Notice.info(i18next.t('loginPage_integration_VALID'));
        onStatus('VALID');
      } else if (
        statusGbdfl === 'INVALID' ||
        statusGbdfl === 'TIMEOUT' ||
        statusZags === 'INVALID' ||
        statusZags === 'TIMEOUT' ||
        statusGbdfl === 'NOT_FOUND' ||
        statusZags === 'NOT_FOUND'
      ) {
        dispatch({ type: LOADING_INTEGRATION, loadingIntegration: false });
        dispatch({
          type: SET_INTEGRATION_STATUS,
          payload: statusGbdfl !== 'VALID' ? statusGbdfl : statusZags
        });
        if (statusGbdfl === 'NOT_FOUND' || statusZags === 'NOT_FOUND') {
          Notice.error(i18next.t('loginPage_integration_NOT_FOUND'));
        }
      } else if (statusGbdfl === 'PENDING' || statusZags === 'PENDING') {
        dispatch({ type: SET_INTEGRATION_STATUS, payload: 'PENDING' });
        onStatus('PENDING');
      }
    }
  } catch (e) {
    handleError(e, i18next.t('loginPage_integrationError'));
    dispatch({ type: LOADING_INTEGRATION, loadingIntegration: false });
  }
};

export const verifyRequestAddress = (currentValueRegionField) => async (dispatch) => {
  try {
    dispatch({ type: LOADING_ACTION, loadingAction: true });
    const { data } = await ServiceRequestApi.getVerifyRequestAddress(
      currentValueRegionField
    );
    const isVerified = data?.status === 'SUCCESS' && data?.result === true ;

    if (isVerified) {
      Notice.success(i18next.t('serviceRequest_addressValid'));
    }

    dispatch({ type: VERIFY_REQUEST_ADDRESS, payload: isVerified });
  } catch (e) {
    const errorCode = _.get(e, 'response.data.errors[0].code');

    if (errorCode === 'error.requester_registration_address_code_not_found') {
      Notice.error(i18next.t('serviceRequest_addressNotFound'));
    } else if (errorCode === 'error.requester_profile_and_actual_area_do_not_match') {
      Notice.error(i18next.t('serviceRequest_addressNotMatch'));
      // handleError(e, i18next.t('serviceProviders_errorVerifyAddress'));
    } else {
      handleError(e, i18next.t('serviceProviders_errorVerifyAddress'));
    }
    dispatch({ type: VERIFY_REQUEST_ADDRESS, payload: false });
  } finally {
    dispatch({ type: LOADING_ACTION, loadingAction: false });
  }
};


export const setIntegrationLoading = status => dispatch => {
  dispatch({ type: LOADING_INTEGRATION, loadingIntegration: status });
};
export const setIntegrationStatus = status => dispatch => {
  dispatch({ type: SET_INTEGRATION_STATUS, payload: status });
};

export const setShowCheckContingentModal = status => ({
  type: SET_SHOW_CHECK_CONTINGENT_MODAL,
  payload: status
});
